<template>
  <el-card class="card-main">
    <el-form inline ref="searchForm">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable filterable placeholder="请选择所属项目" @change="projectChange">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.assessmentType" placeholder="请选择考核大项" clearable>
          <el-option v-for="(item, index) in assessmentTypeList" :label="item.dicValue" :value="item.dicCode"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.scoreNo" size="small" placeholder="请输入考核细则编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.issueStatus" placeholder="请选择工单状态" clearable>
          <el-option v-for="([key, value], index) of orderStatusMap" :label="value" :value="key"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker class="picker" v-model="datePicker" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" v-if="$ButtonShow('add')" type="primary" icon="el-icon-plus">新增工单</el-button>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="考核大项" show-overflow-tooltip prop="assessmentTypeName"></el-table-column>
      <el-table-column label="考核细则编号" show-overflow-tooltip prop="scoreNo"></el-table-column>
      <el-table-column label="工单详情" show-overflow-tooltip prop="issueContent"></el-table-column>
      <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
      <el-table-column label="工单状态" show-overflow-tooltip prop="issueStatus">
        <template v-slot="{ row }">{{ orderStatusMap.get(row.issueStatus) }}</template>
      </el-table-column>
      <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" v-if="row.processId" @click="showProcess(row)">查看</el-button>
          <el-button type="text" v-if="row.processId && $ButtonShow('delete')" @click="delInstance(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </global-pagination>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :node-id="selectInstance.nodeId" :instance-id="selectInstance.instanceId"
        @handler-after="handlerAfter"></instance-preview>
    </el-drawer>

    <w-dialog :ok-loading="submitLoading" :title="`发起 - ${selectForm.formName}`" closeFree width="1100px"
      v-model="openItemDl" okText="提 交" @cancel="openItemDl = false" @ok="submitForm">
      <initiate-process ref="processForm" @render-ok="submitLoading = false" :code="selectForm.formId" v-if="openItemDl"
        @fail="submitLoading = false" @ok="submitSuccess" />
    </w-dialog>
  </el-card>
</template>

<script>
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
import InitiateProcess from "@/views/wflow/workspace/InitiateProcess"
import { delProcessInst } from '@/api/process'
import { orderStatus } from '@/utils/dict'
import { sleep } from '@/utils/util'
export default {
  name: 'AssessmentWorkOrder',
  components: { InstancePreview, InitiateProcess },
  data() {
    return {
      processVisible: false,
      selectInstance: {
        instanceId: '',
        nodeId: ''
      },
      submitLoading: false,
      openItemDl: false,
      searchForm: {
        projectId: '', // 项目Id
        assessmentType: '', // 考核项分类(字典assessmentType)
        scoreNo: '', // 扣分编号
        issueStatus: '', // 问题状态1审批进行中2审批通过3审批被驳回4审批被撤销5审批结束
        startTime: '',
        endTime: ''
      },
      loading: false,
      orderStatusMap: orderStatus,
      assessmentTypeList: [],
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      datePicker: []
    }
  },
  filters: {
  },
  watch: {
  },
  computed: {
    customer() {
      return this.$store.state.customer
    },
    projectList() {
      return this.$store.state.projectList || []
    },
    selectForm() {
      return {
        formName: '考核工单',
        formId: 'wfAC1728887695099' + this.customer
      }
    }
  },
  created() {
    this.loadData()
    this.loadDict()
  },
  methods: {
    projectChange(val) {
      if (!val) {
        this.searchForm.projectId = ''
      }
    },
    dateChange(val) {
      if (val) {
        this.searchForm.startTime = val[0]
        this.searchForm.endTime = val[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'assessmentType' }).then(res => {
        this.assessmentTypeList = res.assessmentType || []
      })
    },
    onSearch() {
      this.page = 1
      this.tableData = []
      this.loadData()
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.assessmentScore.selectLcAssessmentIssueByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then((res) => {
        this.tableData = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onAdd() {
      this.openItemDl = true
      this.submitLoading = true
    },
    delInstance(row) {
      this.$confirm('删除后将失去该流程实例所有数据且无法恢复，是否继续 ?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delProcessInst(row.processId).then(async rsp => {
          await sleep(2000)
          this.loadData()
          this.$ok(rsp, '删除流程实例成功')
        }).catch(err => {
          this.$err(err, '删除流程实例失败')
        })
      })
    },
    async submitSuccess() {
      this.openItemDl = false
      this.submitLoading = false
      await sleep(2000)
      this.loadData()
    },
    submitForm() {
      this.$refs.processForm.validate((validForm, validProcess) => {
        if (validForm && validProcess) {
          this.submitLoading = true
          this.$refs.processForm.submit()
        } else {
          this.$message.warning("请完善表单/流程选项😥")
        }
      })
    },
    showProcess(row) {
      this.processVisible = true
      this.selectInstance = {
        instanceId: row.processId,
        nodeId: row.nodeId
      }
    },
    async handlerAfter() {
      this.processVisible = false
      await sleep(2000)
      this.loadData()
      // node_782868998693
    }
  }
}
</script>

<style scoped lang="scss"></style>
